/**
 * Created by henian.xu on 2018/1/12.
 *
 */
export { default as tabs } from './tabs';
export { default as tabNav } from './tabNav';
export { default as tabPanel } from './tabPanel';
